import React from 'react';
import { SaveButton } from 'react-admin';
import { useFormContext } from 'react-hook-form';

/**
 * SaveButton variant that disables itself when the form has validation errors.
 * React Admin's SaveButton does NOT auto-disable on `formState.isValid` — it must
 * be wired explicitly via `useFormContext().formState`.
 *
 * `disabled` from props is ORed with the invalid state.
 */
export const ValidatedSaveButton: React.FC<React.ComponentProps<typeof SaveButton>> = (props) => {
    const {
        formState: { isValid },
    } = useFormContext();
    const { disabled, ...rest } = props;
    return <SaveButton {...rest} disabled={!!disabled || !isValid} />;
};
